import { User } from "firebase/auth";
import { IEntidadesData } from "../../servicos/entidades/Entidades_FrontAPI";
import { IPager } from "../../servicos/usuarios/Usuario_FrontAPI";
import { IProgramasData } from "src/servicos/programas/Programas_FrontAPI";

export enum ETABLE
{
	USER = 'user',
	PRODUTORA = 'produtora',
	REPOSITORIO = 'repositorio',
	GENERO = 'genero',
	IDIOMA = 'idioma',
	SERIES = 'series',
	PROGRAMAS = 'programas',
	AJUDA = 'ajuda',
}

export interface HeadCell
{
	id: string|number;
	label: string;
	numeric: boolean;
	colSpan?: number;
	sort?: boolean
	align?: string
}

export type ColumnTypes = keyof Record<string, any>;
export type Order = 'asc' | 'desc';

export interface IPropsTableHead 
{
	onRequestSort: (event: React.MouseEvent<unknown>, property: ColumnTypes) => void;
	order: Order;
	orderBy: ColumnTypes | undefined;
	rowCount: number;
	setup: HeadCell[]
	action?: any
	tipo?: ETABLE
}

export interface ITablePaginacao
{
	current_page?: number,
    total_items?: number,
    total_pages?: number,
    items_per_page?: number
}

export interface IPropsTableLIsta
{
	rowsPerPage?: number
	rowsPerPageOptions?: number[]
	paginacao?: ITablePaginacao|null
	setup: HeadCell[]
	action?: any
	tipo?: ETABLE
	// callBackPager: (page:number) => void
}

export interface IPropsTableUserLIsta extends IPropsTableLIsta
{
	lista?: User[]
}
export interface IPropsTableMuiLIsta extends IPropsTableLIsta
{
	lista?: IEntidadesData[] | User[]
}

export interface ITableFilter
{
	titulo?:string,
	order?: Order
}

export interface IPropsTableListaPaginada extends IPropsTableLIsta
{
	lista: IProgramasData[]|IEntidadesData[]|User[]
	pageNumber: number
	rowsPerPage: number
	orderHeranca?: Order
	orderByHeranca?: string
	callback: (rowsPerPage?:number,pageNum?:number, orderBy?: string, order?: Order) => Promise<void>
	handleFilter?: (event: React.MouseEvent<unknown>, filterTitulo: ITableFilter, orderBy?: string) => Promise<void>;
}

export interface IPropsTableBody extends IPropsTableLIsta
{
	// emptyRows: number
	// dense: boolean
}
